import React, { useState, useRef } from 'react';
import { Form, Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import Button, {
  buttonTypes,
  buttonSizes,
  buttonTextSizes,
  buttonFunctions,
} from '../../shared/Button';
import { submitText } from '../../shared/SharedInternationalizations';
import InlineHelpText from '../../shared/InlineHelpText';
import HelpIcon from '../../shared/HelpIcon';

function AsciiConverterForm(props) {
  const { onSubmit } = props;

  const [showAsciiHelpText, setShowAsciiHelpText] = useState(false);
  const asciiHelpTextRef = useRef();
  function toggleAsciiHelpText(value) {
    setShowAsciiHelpText(value);
  }
  const asciiHelpText = (
    <FormattedMessage
      id="asciiConverterForm.passwordHelpText"
      defaultMessage="This is to enter message from Echostream devices and get back the converted result"
      description="Help text."
    />
  );

  return (
    <React.Fragment>
      <div className="add-unit-form__message-container" />
      <Form
        data-test="ascii-converter-form"
        onSubmit={onSubmit}
        render={({
          handleSubmit,
          pristine,
          invalid,
          reset,
          submitting,
          values,
        }) => (
          <form onSubmit={handleSubmit} className="width-100">
            <div className="form__section-container form__section-container--grid">
              <div className="form__item-container">
                <div className="align-center">
                  <label
                    className="text-medium text-bold form-item__field-message--required"
                    htmlFor="name">
                    <FormattedMessage
                      id="asciiConverterForm.messageLable"
                      defaultMessage="Please Enter Echostream message:"
                      description="Enter an updated password for the user"
                    />
                  </label>
                  <HelpIcon
                    onClick={() => asciiHelpTextRef.current.toggleHelpText()}
                    toggled={showAsciiHelpText}
                    styles="margin-left-5"
                  />
                </div>
                <Field
                  className="form-item__field"
                  name="message"
                  component="textarea"
                  rows="5"
                  data-test="echostream-message-input"
                />
              </div>
            </div>
            <div className="width-100 margin-bottom-10">
              <InlineHelpText
                ref={asciiHelpTextRef}
                toggleFunction={toggleAsciiHelpText}
                message={asciiHelpText}
              />
            </div>

            <div className="form__section-container form__section-container--spread">
              <div className="form__items-group-container" />
              <div className="form__items-group-container">
                <Button
                  buttonFunction={buttonFunctions.submit}
                  text={submitText}
                  buttonType={buttonTypes.success}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin margin-left-15"
                  disabled={pristine || invalid}
                />
              </div>
            </div>
          </form>
        )}
      />
    </React.Fragment>
  );
}

export default AsciiConverterForm;
